module.exports = __webpack_public_path__ + "static/media/putin-logo.89fad13d.png";